export const teamHeadshots = {
  quintinBohan: '/images/team/quintin-bohan.jpg',
  ryanCrews: '/images/team/ryan-crews.jpg',
  natalieWilliams: '/images/team/natalie-williams.jpg',
} as const;
